import { partTypeListQuerySchema, type PartTypeView } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listPartTypes } from '../../part-types/part-types.api';

/** Every part type, fetched whole for a column filter: a catalogue this small opens with its choices, and is filtered in the browser. Null until loaded. */
export function usePartTypeOptions(): PartTypeView[] | null {
  const [types, setTypes] = useState<PartTypeView[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    listPartTypes(partTypeListQuerySchema.parse({ pageSize: 100 }))
      .then((page) => !cancelled && setTypes(page.items))
      .catch(() => !cancelled && setTypes([]));
    return () => {
      cancelled = true;
    };
  }, []);

  return types;
}
